import { render } from "./InterventionalCardiology.vue?vue&type=template&id=7083faef&scoped=true"
import script from "./InterventionalCardiology.vue?vue&type=script&lang=ts"
export * from "./InterventionalCardiology.vue?vue&type=script&lang=ts"

import "./InterventionalCardiology.vue?vue&type=style&index=0&id=7083faef&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7083faef"

export default script